import React, { useState, useEffect } from 'react';
import MetaTitle from '../components/MetaTitle';
import { Link, useNavigate } from 'react-router-dom';
import "../assete/css/home.css";
// import researc_pic_1 from "../assete/home/Research-removebg-preview - Copy-min.png";
import icon_logo from "../assete/icon/res.png";
import Email_pic from "../assete/icon/mail.png";
import soft_pic from "../assete/icon/softwe.png";
import web_pic from "../assete/icon/web.png";
import appa_pic from "../assete/icon/app.png";
import vidroapp_pic from "../assete/icon/video.png";
//import ad_pic from "../assete/home/22-removebg-preview (1).png";
import next_pic from "../assete/newimages/Untitled_design__10_-removebg-preview.png";
import tech_pic from "../assete/icon/technologys.png";
import innovation_pic from "../assete/icon/inovation.png";
import intergation_pic from "../assete/icon/intraction (1).png";
import lens_pic from "../assete/home/ad3.jpg";
import mision_pic from "../assete/home/video-1-1-min.jpg";
import Footer from './Footer';
import head_vbido from "../assete/newimages/Untitled design (4) (2).png";
import reserach_pall_1 from "../assete/home/Research-4-removebg-preview-min.png";
import starRatingImage from "../assete/home/1-removebg-preview-min.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { ContactusApi, ViewReviewDetailsApi } from '../service/Api';
import Header from './Header';
import extra_line_pic from "../assete/home/line.jpg";
import Scrolltop from './Scrolltop';
import conts_extr_pic_4 from "../assete/home/contact-thumb1.png";
import conts_extr_pic_5 from "../assete/home/contact-shape.png";
import inavtive_pic from "../assete/newimages/600600.png";
import inavtive_pic_2 from "../assete/newimages/book.png";
import ball_pic_1 from "../assete/home/ball1.png";
import satr_pic_1 from "../assete/home/call-shape2.png";
import Whatsapp from './Whatsapp';
import CountUp from 'react-countup';
import ScrollTrigger from "react-scroll-trigger";
import sub_new_design_pic from "../assete/newimages/pic_2.png";
import company from "../assete/newimages/Untitled_design__5_-removebg-preview.png";
import role_pic from "../assete/newimages/dot-circle.png";
import reserch_pic_1 from "../assete/newimages/graduation_t20_yv8gA6-2.jpg";
import reserch_pic_2 from "../assete/newimages/pexels-photo-267885.webp";
import advance_pic_1 from "../assete/newimages/advance 1.jpg";
import advance_pic_2 from "../assete/newimages/advance 3.avif";
import advance_pic_3 from "../assete/newimages/advance 2.png";

const Home = () => {
  const [activeSection, setActiveSection] = useState('vision');

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };




  useEffect(() => {
    AOS.init({
      duration: 600,
      delay: 300
    });
  }, []);



  const [formData, setFormData] = useState({
    user_name: '',
    user_phone: '',
    user_email: '',
    service_type: '',
    user_message: '',
  });

  const [errorMessage, setErrorMessage] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };


  const handleSubmit = async () => {
    let errors = {};


    if (!/^[A-Za-z\s]+$/.test(formData.user_name.trim())) {
      errors.user_name = 'Enter your Name';
    }

    if (!/^[0-9]{10}$/.test(formData.user_phone.trim())) {
      errors.user_phone = 'Phone number must be 10 digits.';
    }

    if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.user_email.trim())) {
      errors.user_email = 'Enter a valid email address.';
    }

    if (formData.service_type.trim() === '' || formData.service_type === 'select*') {
      errors.service_type = 'Please select a service type.';
    }

    if (formData.user_message.trim() === '') {
      errors.user_message = 'Message cannot be empty.';
    }


    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setTimeout(() => {
        setErrorMessage('');
      }, 2000);
      return;
    }

    try {
      setErrorMessage('');
      const response = await ContactusApi(formData);
      console.log('Form data saved:', response.data);

      setSuccessMessage('submitted successfully!');
      setFormData({
        user_name: '',
        user_phone: '',
        user_email: '',
        service_type: '',
        user_message: '',
      });

      setTimeout(() => {
        setSuccessMessage('');
      }, 2000);
    } catch (error) {
      console.error('Error saving form data:', error);
      setErrorMessage('Failed to submit the form. Please try again.');
    }
  };



  const navigate = useNavigate();

  const phd_peoposal = () => {
    navigate("");


    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  };

  const [counterOn, setCounterOn] = useState(false);

  const [details, setDetails] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ViewReviewDetailsApi();
        if (response && response.review) {
          setDetails(response.review.reverse());
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  useEffect(() => {

    if (details.length > 0) {
      const interval = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % details.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [details]);



  return (
    <>
      <MetaTitle title=" " />
      <meta name="description" content="SEA SENSE provides research guidance, thesis writing, and software development services in Marthandam, Tamil Nadu. Specializing in PhD assistance and software solutions." />
      <meta name="keywords" content="SEA SENSE, Sea Sense Softwares,  PhD guidance in Marthandam | 
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships | Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari | PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu | 
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil | PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum | PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey | PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai | PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai | PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy | PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli | PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore | PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india | PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam | PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin | PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam | PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |	 " />
      <meta name="copyright" content="Sea Sense IT SOLUTION Sea Sense  MARTHANDAM |  PhD guidance in Marthandam | 
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |
Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships | 
Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari | 
PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |
Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu | 
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |
Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil | 
PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |
Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum | 
PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey | 
PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |
Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai | 
PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |
Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai | 
PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |
Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy | 
PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |
Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli | 
PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |
Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore | 
PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india | 
PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |
Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam | 
PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |
Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin | 
PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |
Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam | 
PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |
Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |	 Sea Sense  SOFTWARE |Sea Sense  SOFTWARES | Sea Sense  INFOTECH |Sea Sense 
        ITS | Sea Sense  IT SOLUTIONS | MARTHANDAM SOFTWARES | MARTHANDAM SOFTWARE |NAGERCOIL SOFTWARES
        |NAGERCOIL SOFTWARE | SUPER MARKET MANAGEMENT SYSTEM MARTHANDAM | Sea Sense  KUZHITHURAI
        | Sea Sense  ITS INDIA | Sea Sense  IT TAMILNADU | Sea Sense  IT KANNIYAKUMARI | Sea Sense  IT WORLD NO:1 | Sea Sense  IT
        NO:1 MARTHANDAM | Sea Sense  IT NO:1 NAGERCOIL| Sea Sense Softwares Private Limited | SUPERMARKET
        MANAGEMENT SYSTEM NAGERCOIL |WORLD NO:1 IT SOLUTION | WORLD NO:1 IT SOLUTIONS |Sea Sense 
       Softwares Private Limited | Sea Sense  IT SOFTWARE SOLUTION MARTHANDAM | Sea Sense  IT SOLUTION NAGERCOIL
        |Sea Sense  | Sea Sense IT | Sea Sense  INDIA | Sea Sense  ITS INDIA | BEST SOFTWARE DEVELOPING COMPANY IN INDIA | BEST SOFTWARE 
        DEVELOPING COMPANY IN TAMILNADU |BEST SOFTWARE DEVELOPING COMPANY IN KERALAM |
        BEST SOFTWARE DEVELOPING COMPANY IN CHENNAI | BEST SOFTWARE DEVELOPING COMPANY IN TRIVANDRUM | 
        BEST SOFTWARE DEVELOPING COMPANY IN BANGLORE | BEST SOFTWARE DEVELOPING COMPANY IN KANYAKUMARI | 
        BEST SOFTWARE DEVELOPING COMPANY IN NAGERCOIL | BEST SOFTWARE DEVELOPING COMPANY IN Singapore | 
        BEST SOFTWARE DEVELOPING COMPANY IN MARTHANDAM | WORLD NUMBER ON SOFTWARE COMPANY | 
        SOFTWARE DEVELOPING COMPANIES | TOP TEN SOFTWARE DEVELOPING COMPANY IN INDIA | IT SOLUTION | 
        BE PROJECTS | M.TECH PROJECTS | ME PROJECTS | B.TECH PROJECTS | COLLEGE PROJECTS IN KANYAKUMARI | 
        COLLEGE PROJECTS IN MARTHANDAM| COLLEGE PROJECTS IN TAMILNADU | B.SC M.SC POLYTECHNIC PROJECTS IN TAMILNADU
        | B.SC M.SC POLYTECHNIC PROJECTS MARTHANDAM | B.SC M.SC POLYTECHNIC PROJECTS NAGERCOIL
        | B.SC M.SC POLYTECHNIC PROJECTS KANYAKUMARI | WEBSITE DEVELOPING | HOW TO DEVELOP A WEBSITE | billing software in Singapore|super market billing software in Singapore|jewellery billing software in Singapore|traders billing software in Singapore|church billing software in Singapore|mobile shop billing software in Singapore|spare parts billing software in Singapore|textile billing software in Singapore|retail billing software in Singapore|medical shop billing software in Singapore|medical store billing software in Singapore|best billing software in Singapore" />
      <meta name="robots" content="index,follow Sea Sense  MARTHANDAM | Sea Sense  SOFTWARE |Sea Sense  SOFTWARES | PhD guidance in Marthandam | 
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |
Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships | 
Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari | 
PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |
Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu | 
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |
Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil | 
PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |
Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum | 
PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey | 
PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |
Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai | 
PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |
Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai | 
PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |
Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy | 
PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |
Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli | 
PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |
Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore | 
PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india | 
PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |
Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam | 
PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |
Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin | 
PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |
Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam | 
PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |
Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |	
	|Sea Sense ITS | Sea Sense  IT SOLUTIONS | MARTHANDAM SOFTWARES | MARTHANDAM SOFTWARE |NAGERCOIL SOFTWARES
        |NAGERCOIL SOFTWARE | SUPER MARKET MANAGEMENT SYSTEM MARTHANDAM | Sea Sense  KUZHITHURAI
        | Sea Sense  ITS INDIA | Sea Sense  IT TAMILNADU | Sea Sense  IT KANNIYAKUMARI | Sea Sense  IT WORLD NO:1 | Sea Sense  IT
        NO:1 MARTHANDAM | Sea Sense  IT NO:1 NAGERCOIL| Sea Sense Softwares Private Limited | SUPERMARKET
        MANAGEMENT SYSTEM NAGERCOIL |WORLD NO:1 IT SOLUTION | WORLD NO:1 IT SOLUTIONS |Sea Sense 
       Softwares Private Limited | Sea Sense  IT SOFTWARE SOLUTION MARTHANDAM | Sea Sense  IT SOLUTION NAGERCOIL
        |Sea Sense  | Sea Sense IT | Sea Sense  INDIA | Sea Sense  ITS INDIA |BEST SOFTWARE DEVELOPING COMPANY IN INDIA | BEST SOFTWARE DEVELOPING COMPANY IN TAMILNADU |
 BEST SOFTWARE DEVELOPING COMPANY IN KERALAM
BEST SOFTWARE DEVELOPING COMPANY IN CHENNAI | BEST SOFTWARE DEVELOPING COMPANY IN TRIVANDRUM | 
BEST SOFTWARE DEVELOPING COMPANY IN BANGLORE | BEST SOFTWARE DEVELOPING COMPANY IN KANYAKUMARI | 
BEST SOFTWARE DEVELOPING COMPANY IN NAGERCOIL | BEST SOFTWARE DEVELOPING COMPANY IN Singapore | 
BEST SOFTWARE DEVELOPING COMPANY IN MARTHANDAM | WORLD NUMBER ON SOFTWARE COMPANY | 
SOFTWARE DEVELOPING COMPANIES | TOP TEN SOFTWARE DEVELOPING COMPANY IN INDIA | IT SOLUTION | 
BE PROJECTS | M.TECH PROJECTS | ME PROJECTS | B.TECH PROJECTS | COLLEGE PROJECTS IN KANYAKUMARI | 
 COLLEGE PROJECTS IN MARTHANDAM| COLLEGE PROJECTS IN TAMILNADU | B.SC M.SC POLYTECHNIC PROJECTS IN TAMILNADU
 | B.SC M.SC POLYTECHNIC PROJECTS MARTHANDAM | B.SC M.SC POLYTECHNIC PROJECTS NAGERCOIL
 | B.SC M.SC POLYTECHNIC PROJECTS KANYAKUMARI | WEBSITE DEVELOPING | HOW TO DEVELOP A WEBSITE | | billing software in Singapore|super market billing software in Singapore|jewellery billing software in Singapore|traders billing software in Singapore|church billing software in Singapore|mobile shop billing software in Singapore|spare parts billing software in Singapore|textile billing software in Singapore|retail billing software in Singapore|medical shop billing software in Singapore|medical store billing software in Singapore|best billing software in Singapore
" />

      <Header />

      <div className='seasense_new_head_design'>
        <img src={head_vbido} alt="" />

        <div className='seasense_web_content_container'>

          <div className="content-container" data-aos="zoom-in" data-aos-duration="2000">

            <h2 className='hemihead'>SEA SENSE</h2>
            <h1>An Innovative Research & Development Solutions</h1>
            <p>We provide specialized software development services to help improve your business process and integrate different platforms. We design, develop, test and integrate software act across multiple platforms, including mobile applications.
            </p>
            <button className="explore-button"><Link to="/Contact">Explore More</Link></button>
          </div>
        </div>

      </div>


      <div className='new_padd_card'>

        <div className='seasense_hom_about'>
          <div className='seasense_hom_about_1'>

            <div className='hom_about_conts_seasense'>
              <img src={role_pic} alt="" className='circle_role' />
              <h3 data-aos="fade-down" data-aos-duration="1500">ABOUT COMPANY </h3>
              <h1 data-aos="fade-up" data-aos-duration="1500" >Get Research Solutions For project</h1>
              <h2 data-aos="zoom-in" data-aos-duration="1500">SHORT HISTORY</h2>
              <p data-aos="zoom-in" data-aos-duration="1500">Welcome to Sea Sense Research, a pioneering company with over a decade of experience in Research guidance. Our skilled team has supported 5,000+ scholars, facilitating 1,500+ research publications. We offer a seamless experience through a single control panel and state-of-the-art cloud services. As a root-level company, we provide robust infrastructure and toll-free customer support, ensuring unparalleled assistance for your academic journey.</p>
            </div>
            <div className='seasense_hom_about_2'>
              <img src={company} alt="" />
            </div>
          </div>
        </div>




        <div className='new_research_main_div'>
          <div className='new_research_main_div_1'>
            <div className='new_research_main_div_2'>
              <img src={reserch_pic_1} alt="" data-aos="fade-down" data-aos-duration="1500" />
              <div className='new_design_research_conts_div'>
                <div className='new_design_research_conts_div_1' data-aos="fade-up" data-aos-duration="1500">
                  <h2>Best Research Assistance In India</h2>
                  <p>Sea Sense is a top Research Assistance service in India, known for its excellent support for academics in doctorate research. Our team has experienced Research professionals with diverse academic backgrounds. Each scholar acquires specific instructions for their field of study. Sea Sense provides comprehensive support for project implementation and research papers, which includes developing research proposal, building methodologies and preparing manuscripts for publication. We prioritize high standards in data analysis. Our researchers use various methods to ensure accurate study results. Sea Sense is proud of researchers who submitted their Thesis and achieved publication, advancing their academic careers. Sea Sense is a reliable academic advisor who values confidentiality and transparency. Clients could reach out to us to schedule a consultation for customized professional advice that meets their research needs.</p>
                </div>
              </div>
            </div>
            <div className='add_new_pic_design_research'>
              <div className='add_new_pic_design_research_1' data-aos="fade-up" data-aos-duration="1500">
                <h2>Sea Sense Research</h2>
                <p>At Sea Sense Research, we understand the challenges that scholars face in their research endeavors. Whether you are working on journal publications, thesis writing, or data analysis, our expert team is dedicated to providing personalized guidance at every stage. We specialize in assisting scholars with literature reviews, research methodologies, plagiarism checks, and manuscript preparation to meet global academic standards. With a strong emphasis on innovation and knowledge dissemination, we collaborate with leading universities, research institutions, and publishing platforms to ensure that your work gains the recognition it deserves. Our services cater to scholars from diverse fields, including engineering, medicine, social sciences, and management studies. Join Sea Sense Research and embark on a journey of academic excellence with trusted mentorship, cutting-edge resources, and unwavering support. As a root-level company, we provide robust infrastructure and toll-free customer support.</p>
              </div>
              <div className='add_design_pic_research'>
                <img src={reserch_pic_2} alt="" data-aos="fade-down" data-aos-duration="1500" />
              </div>

            </div>

          </div>
        </div>




        <div className='inavative_seasense_main_div'>

          <div className='inavative_seasense_main_div_1'>
            <div className='inavative_pic_add'>

              <img src={inavtive_pic} alt="" />
            </div>

            <div className='inavte_conts_div'>
              <img src={ball_pic_1} alt="" className='animate-image' />
              <img src={ball_pic_1} alt="" className='animate-image absolute_pic' />
              <img src={satr_pic_1} alt="" className='start_pic_rotate animate-rotational' />
              <h2>An Innovative Research & Development Solution</h2>
              <div className='invate_sub_div'>
                <p>You can also send us email and we’ll get in touch shortly.</p>
                <p style={{fontWeight:"bold"}}>
                  <Link to="mailto:info@seasensesoftwares.com" style={{color:"#00000",textDecoration:"none"}}>info@seasensesoftwares.com</Link></p>
              </div>
            </div>
            <div className='inavative_pic_add'>
              <img src={inavtive_pic_2} alt="" />
            </div>
          </div>
        </div>
        <div className='nddk'>
          <div className='seasense_web_next_div'>
            <div className='seasense_web_next_div_1'>
              <div className='seasense_web_next_div_2'>
                <img src={next_pic} alt="" data-aos="zoom-in" data-aos-duration="2000" />
              </div>

              <div className='seasense_web_next_div_conts'>
                <div className='seasense_web_next_div_conts_1'>
                  <h2>Taking Your Research To The Next Level</h2>
                  <p>Are you ready to elevate your research to new heights? Our Sea Sense Research assistance services are designed to take your research to the next level, helping you unlock its full potential and make a significant impact in your field. With our expertise and guidance, you can surpass the ordinary and delve into the extraordinary. We provide the necessary support and resources to help you tackle the most challenging aspects of your research, pushing boundaries and driving innovation.Advancing your research requires a strategic approach that combines innovation, collaboration, and continuous learning. Begin by critically assessing your current methods and identifying any gaps or limitations. Setting clear objectives is crucial—know what you want to achieve and prioritize the areas that need improvement.Adopting new technologies, such as AI and advanced data analytics, can greatly enhance the accuracy and scope of your research. Don't hesitate to explore interdisciplinary approaches that could offer fresh perspectives. Collaboration is another key component; engaging with the research community and forming partnerships with experts can provide valuable insights and resources.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='add_extre_pic_line'>
          <img src={extra_line_pic} alt="" loading="lazy" />
        </div>

        <div className='seasense_web_tec_1'>
          <div className='seasense_best_div'>
            <h2>WE ARE ALWAYS THE BEST</h2>
          </div>
          <div className='seasense_web_tech_main_div'>
            <div className='seasense_web_tech_div'>
              <div className='seasenseweb_tect_div_conts'>
                <div className='seasense_web_change_place'>
                  <div className='seasense_tect_div_pic_add'>
                    <img src={tech_pic} alt="" data-aos="zoom-in" data-aos-duration="2000" loading="lazy" />
                  </div>
                  <div className='seasense_web_cost_div_tech'>
                    <h2 data-aos="fade-down">Technology</h2>
                    <p data-aos="zoom-in" data-aos-duration="2000">Sea Sense leverages cutting-edge technology to enhance research support and resources. By integrating advanced tools and platforms, we aim to deliver seamless, accurate and efficient solutions for our clients.</p>
                  </div>
                </div>
                <div className='seasense_web_change_place'>
                  <div className='seasense_tect_div_pic_add'>
                    <img src={innovation_pic} alt="" data-aos="zoom-in" data-aos-duration="2000" loading="lazy" />
                  </div>
                  <div className='seasense_web_cost_div_tech'>
                    <h2 data-aos="fade-down">Innovation</h2>
                    <p data-aos="zoom-in" data-aos-duration="2000">We implement innovative solutions to streamline and improve the academic research process, ensuring excellence and efficiency at every stage.</p>
                  </div>
                </div>
                <div className='seasense_web_change_place'>
                  <div className='seasense_tect_div_pic_add'>
                    <img src={intergation_pic} alt="" data-aos="zoom-in" data-aos-duration="2000" loading="lazy" />
                  </div>
                  <div className='seasense_web_cost_div_tech'>
                    <h2 data-aos="fade-down">Integration</h2>
                    <p data-aos="zoom-in" data-aos-duration="2000">Our integrated approach combines various tools and methodologies for comprehensive research guidance, ensuring a seamless and efficient experience for researchers.</p>
                  </div>
                </div>

              </div>
            </div>
            <div className='seasense_web_innovation_pic_add'>
              <img src={lens_pic} alt="" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500" />
            </div>
          </div>
        </div>

        <div className='new_web_design_seasese'>
          <div className='new_web_design_seasese_1'>

            <div className='new_sub_div_web_design_seasense'>
              <div className='new_sub_div_web_design_seasense_1'>
                <img src={sub_new_design_pic} alt="" />
              </div>
            </div>
            <div className='new_web_design_seasese_2' data-aos="fade-down" data-aos-duration="1500">
              <p>A scholar is a person dedicated to the pursuit of knowledge and learning. They engage in deep research, critical thinking, and analysis to contribute to their field of study. Scholars often specialize in subjects like science, literature, history, or philosophy, advancing human understanding through their work. They publish research papers, books, and articles to share their findings with the academic community. Many scholars work in universities, research institutions, or think tanks, mentoring students and guiding new researchers. Their dedication to education helps shape the future by inspiring new ideas and discoveries. Scholars value curiosity, discipline, and a lifelong commitment to learning.</p>
            </div>
          </div>
        </div>
      </div>


      <div className='tt'>
        <div className='timeline'>
          <div className='seasense_web_ser_div'>
            <h2>Our Service</h2>
          </div>
          <div className='center-line'></div>
          <div className='container left-container'>
            <img src={icon_logo} alt="icon" loading="lazy" />
            <div className='text-box' data-aos="fade-down" data-aos-duration="5000">
              <small>RESEARCH SERVICES</small>
              <p>Sea Sense provides research assistance service to the research scholars of various domains from Topic selection to paper acceptance.</p>
              <span className='left-container-arrow'></span>
            </div>
          </div>

          <div className='container right-container'>
            <img src={Email_pic} alt="icon" loading="lazy" />
            <div className='text-box' data-aos="fade-down" data-aos-duration="5000">
              <small>E-Mail SERVICES</small>
              <p>SEA SENSE is a leading Digital Company, which provides bulk promotional and Transactional E-Mail service around globe with Templates.</p>
              <span className='right-container-arrow'></span>
            </div>
          </div>

          <div className='container left-container'>
            <img src={soft_pic} alt="icon" loading="lazy" />
            <div className='text-box' data-aos="fade-down" data-aos-duration="5000">
              <small>SOFTWARE SERVICES</small>
              <p>SEA SENSE is a Software Development Company, which provides the best software services all over India.</p>
              <span className='left-container-arrow'></span>
            </div>
          </div>

          <div className='container right-container'>
            <img src={web_pic} alt="icon" loading="lazy" />
            <div className='text-box' data-aos="fade-down" data-aos-duration="5000">
              <small>WEB HOSTING</small>
              <p>It is important for every company to have its own website so that it can act as a convenient platform where customers and clients can get to know everything.</p>
              <span className='right-container-arrow'></span>
            </div>
          </div>

          <div className='container left-container'>
            <img src={appa_pic} alt="icon" loading="lazy" />
            <div className='text-box' data-aos="fade-down" data-aos-duration="5000">
              <small>APPS MARKETING</small>
              <p>Useful Android apps can transform the operational efficiency of enterprises and bring a very flexible feature.</p>
              <span className='left-container-arrow'></span>
            </div>
          </div>

          <div className='container right-container'>
            <img src={vidroapp_pic} alt="icon" loading="lazy" />
            <div className='text-box' data-aos="fade-down" data-aos-duration="5000">
              <small>VIDEO MARKETING</small>
              <p>The rapidly evolving technology has created new areas and ways that allow for effective promotion, marketing and advertising possibilities.</p>
              <span className='right-container-arrow'></span>
            </div>
          </div>
        </div>
      </div>



      <div className='new_padd_card_1'>
        <div className='advnace_code_new_design'>
          <div className='advnace_code_new_design_1'>
            <div className='advnace_code_new_design_2'>
              <div className='advnace_code_new_design_3'>
                <img src={advance_pic_2} alt="" />
                <img src={advance_pic_1} alt="" />
              </div>
              <div className='advnace_code_new_design_4'>
                <img src={advance_pic_3} alt="" />
              </div>
            </div>
            <div className='advance_code_new_design_conts_div' >
              <h2>ADVANCED CODING SOLUTIONS FOR YOUR PROJECT</h2>
              <p>At SEA SENSE, we specialize in providing high-quality software coding services to meet the diverse needs of our clients. With our team of experienced developers and engineers, we are committed to delivering innovative and customized solutions that leverage the latest technologies.Modular programming allows developers to break down complex problems into smaller, manageable pieces. This approach promotes code reusability, easier debugging, and streamlined collaboration.Implementing regular code reviews helps maintain code quality and knowledge sharing within the team. Peer reviews can catch potential bugs and improve overall code readability.Regularly refactoring code improves its structure without changing its functionality. This practice enhances readability, reduces technical debt, and makes future updates easier.At Sea Sense Technologies, we provide advanced coding solutions tailored to meet the unique needs of your project. Whether you are working on a small-scale application or a complex enterprise system, we leverage the latest technologies and best practices to deliver high-performance, scalable, and maintainable code.</p>
            </div>
          </div>
        </div>


        <div className='seasense_vision_main_div'>
          <div className='seasense_vision_div_1'>
            <div className='seasense_vision_div_2'>
              <h2 data-aos="fade-up" data-aos-duration="2000">Best IT-Solution </h2>
              <p data-aos="fade-up" data-aos-duration="2000">Our team heads have rich experience in the field of research for more than 15 years especially in the development of questionnaire, research design, quantitative and qualitative study designs, and statistical analysis. The technical heads will guide you through your research journey to achieve your Research. There is complete support at every stage from the identification of Research topic to the final document.</p>

              <br />

              <div className='seasense_vision_btns'>
                <button className={activeSection === 'vision' ? 'active' : ''} onClick={() => handleSectionChange('vision')} >Vision</button>
                <button className={activeSection === 'mission' ? 'active' : ''} onClick={() => handleSectionChange('mission')} >Mission</button>
                <button className={activeSection === 'goal' ? 'active' : ''} onClick={() => handleSectionChange('goal')} >Goal</button>
              </div>
              {activeSection === 'vision' && (
                <div className='ses_clr_set'>
                  <h2 data-aos="zoom-out-up" data-aos-duration="2000">Vision</h2>
                  <p data-aos="zoom-out-up" data-aos-duration="2000">Sea Sense aspires to become the world’s leading research guidance provider by offering a holistic approach that transcends subjects, countries, and academic specializations. With a focus on inclusivity and adaptability, Sea Sense aims to provide personalized, high-quality support to researchers, students, and professionals across diverse fields.By fostering innovation, critical thinking, and collaboration, the organization seeks to empower individuals and organizations to achieve their research goals, making a global impact and advancing knowledge in all corners of the world.</p>
                </div>
              )}

              {activeSection === 'mission' && (
                <div className='ses_clr_set'>
                  <h2 data-aos="zoom-out-up" data-aos-duration="2000">Mission</h2>
                  <p data-aos="zoom-out-up" data-aos-duration="2000">To achieve this vision, Sea Sense employs a unique methodology for each research project, ensuring a tailored approach that meets the specific needs of the subject and context. This process involves extensive discussions and collaboration with a diverse group of experts, including research specialists, professors, data management professionals, industry leaders, and technical and language editors. By integrating insights from various fields, Sea Sense ensures that every research endeavor is supported by comprehensive expertise, leading to high-quality, accurate, and impactful outcomes that align with the highest academic and professional standards.</p>
                </div>
              )}

              {activeSection === 'goal' && (
                <div className='ses_clr_set'>
                  <h2 data-aos="zoom-out-up" data-aos-duration="2000">Goal</h2>
                  <p data-aos="zoom-out-up" data-aos-duration="2000">Are you ready to elevate your research to new heights? At Sea Sense, our Research Assistance Services are designed to empower you with the tools, expertise, and insights needed to unlock the full potential of your research. Whether you're an academic, professional, or an organization looking to push the boundaries of knowledge, we provide comprehensive support at every stage of your research journey. From data analysis and methodology design to paper writing and publication strategy, our team ensures your research stands out, drives innovation, and makes a lasting impact in your field.</p>
                </div>
              )}

            </div>
            <div className='seasense_mision_pic'>
              <img src={mision_pic} alt="" loading="lazy" />
            </div>
          </div>
        </div>
      </div>

      <div className='seasense_extrat_card_div_add_pic'>
        <div className='seasense_extera_cont_div'>
          <div className='seasense_extra_conts_add'>
            <div className='play-button'>
              <h4><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={"50px"} color='#fff' style={{ marginTop: "-30px" }}><path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path></svg></h4>
            </div>

            <h2>Call Us Anytime </h2>
            <h1>+91 85 26 700 700</h1>
            <p>Welcome to Sea Sense Research, where we empower scholars with expert support and guidance. Our services include research  development.</p>
            <div className='extr_conts_btn'>
              <button className='extr_conts_btn_new_list'><Link to="/Contact" onClick={phd_peoposal}>Click</Link></button>
            </div>
          </div>
          <div className='extert_seasense_pic_add_cont'>
            <div className='exte_pic_2'>
              <img src={conts_extr_pic_5} alt="" className='animate-image' />
            </div>
            <img src={conts_extr_pic_4} alt="" />
          </div>
        </div>
      </div>
      <div className='tergert_pic_add'>
        <div className='seasense_terget_main_div'>
          <div className='seasense_target_div'>
            <div className='seasense_targrt_conts_div'>
              <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                <div className='count_div' >

                  <h2 data-aos="fade-down" data-aos-duration="1000"> {counterOn && <CountUp start={0} end={5000} duration={2} delay={0} />}+</h2>
                  <p>Happy clients</p>
                </div>
              </ScrollTrigger>

            </div>
            <div className='seasense_targrt_conts_div'>
              <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                <div className='count_div' >

                  <h2 data-aos="fade-down" data-aos-duration="1000"> {counterOn && <CountUp start={0} end={10000} duration={2} delay={0} />}+</h2>
                  <p>Completed Projects</p>
                </div>
              </ScrollTrigger>

            </div>
            <div className='seasense_targrt_conts_div'>
              <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                <div className='count_div' >

                  <h2 data-aos="fade-down" data-aos-duration="1000"> {counterOn && <CountUp start={0} end={99} duration={2} delay={0} />}%</h2>
                  <p>Satisfaction Rate</p>
                </div>
              </ScrollTrigger>

            </div>
            <div className='seasense_targrt_conts_div'>
              <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
                <div className='count_div' >

                  <h2 data-aos="fade-down" data-aos-duration="1000"> {counterOn && <CountUp start={0} end={100} duration={2} delay={0} />}+</h2>
                  <p>Qualified Experts </p>
                </div>
              </ScrollTrigger>


            </div>

          </div>
        </div>
      </div>


      <div className='new_padd_card_2'>
        <div className='seasense_research_boll_2'>
          <div className='seasense_research_boll'>
            <div className='seasense_research_boll_1' data-aos="fade-right" data-aos-duration="2000">
              <h2>Sea Sense Research </h2>

              <p>Welcome to Sea Sense Research, where we empower scholars with expert support and guidance. Our services include research proposal development, literature review assistance, data analysis, manuscript preparation and academic coaching. With a team of experienced researchers, we provide personalized and timely help to enhance the quality and impact of your work. Choose Sea Sense Research for excellence and integrity in academic support. Our mission is to enable academic excellence and transform your research journey into a seamless and enriching experience. At Sea Sense, we understand the complexities of academic pursuits and the challenges scholars face. That’s why our services are tailored to meet your unique needs and deliver results that surpass your expectations. We believe that your success is our success. We aim to build lasting relationships with scholars by consistently exceeding expectations and contributing to their academic growth. </p>
            </div>
            <div className='seasense_boll_pic_add' data-aos="fade-down" data-aos-duration="2000" >
              <img src={reserach_pall_1} alt="" className='animate-image' />
            </div>
          </div>
        </div>
      </div>
      <div className='new_design_review_main_div'>
        <div className='design_new_div'>
          <div className='design_new_div_1'>
            <div className='design_review_div'>
              <img src={starRatingImage} alt="Star Rating" />
              {details.length > 0 ? (
                <>

                  <h2>{details[index].name}</h2>
                  <p style={{ wordWrap: "break-word", }}>{details[index].review}</p>
                </>
              ) : (
                <p></p>
              )}
            </div>
          </div>
          <div className='design_card_div'>
            <div className='design_card_div_1'>
              <h1>TESTMONIALS</h1>
              <h2>What They Say About Us?</h2>
              <p>"Seasense Scholar has been an incredible platform for enhancing my learning experience. The well-structured courses, insightful resources, and expert guidance have helped me gain in-depth knowledge in my field".</p>
            </div>
          </div>
        </div>
      </div>


      <div className='new_contact_div'>
        <div className='new_contact_div_1'>
          <div className='new_contsct_div_conts'>
            <h2>CONTACT US</h2>
            <h1>Have Any Questions? Let's Answer Them</h1>
            <label><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M9.36556 10.6821C10.302 12.3288 11.6712 13.698 13.3179 14.6344L14.2024 13.3961C14.4965 12.9845 15.0516 12.8573 15.4956 13.0998C16.9024 13.8683 18.4571 14.3353 20.0789 14.4637C20.599 14.5049 21 14.9389 21 15.4606V19.9234C21 20.4361 20.6122 20.8657 20.1022 20.9181C19.5723 20.9726 19.0377 21 18.5 21C9.93959 21 3 14.0604 3 5.5C3 4.96227 3.02742 4.42771 3.08189 3.89776C3.1343 3.38775 3.56394 3 4.07665 3H8.53942C9.0611 3 9.49513 3.40104 9.5363 3.92109C9.66467 5.54288 10.1317 7.09764 10.9002 8.50444C11.1427 8.9484 11.0155 9.50354 10.6039 9.79757L9.36556 10.6821ZM6.84425 10.0252L8.7442 8.66809C8.20547 7.50514 7.83628 6.27183 7.64727 5H5.00907C5.00303 5.16632 5 5.333 5 5.5C5 12.9558 11.0442 19 18.5 19C18.667 19 18.8337 18.997 19 18.9909V16.3527C17.7282 16.1637 16.4949 15.7945 15.3319 15.2558L13.9748 17.1558C13.4258 16.9425 12.8956 16.6915 12.3874 16.4061L12.3293 16.373C10.3697 15.2587 8.74134 13.6303 7.627 11.6707L7.59394 11.6126C7.30849 11.1044 7.05754 10.5742 6.84425 10.0252Z"></path></svg>91+ 85 26 700 700</label>
            <label><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM2 4C2 3.44772 2.44772 3 3 3H14V5H4.5052L12 11.662L16.3981 7.75259L17.7269 9.24741L12 14.338L4 7.22684V19H20V11H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4Z"></path></svg>info@seasensesoftwares.com</label>
            <label><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z"></path></svg>Sea Sense Interdisciplinary Research and IT Solution (OPC) Pvt. Ltd.</label>
            <div style={{marginLeft:"32px"}}>
              <label>JJ Arcade, Second Floor Near New Bus Stand</label>

              <label>Marthandam, Kanyakumari District</label>
              <label>Tamil Nadu, India - 629165</label>
            </div>
         
          </div>
          <div className='new_cont_input_pic'>
            <div className='new_contact_input_form'>
              <div className='new_contact_input'>
                <input type="text" placeholder='Enter your Name' id="user_name" value={formData.user_name} onChange={handleChange} />
                {errorMessage.user_name && <div className="error-message" style={{ color: 'red', fontSize: "10px" }}>{errorMessage.user_name}</div>}
                <input type="text" placeholder='Enter your Number' id="user_phone" value={formData.user_phone} onChange={handleChange} />
                {errorMessage.user_phone && <div className="error-message" style={{ color: 'red', fontSize: "10px" }}>{errorMessage.user_phone}</div>}
              </div>
              <div className='new_contact_input'>
                <input type="email" placeholder='Enter your Email' id="user_email" value={formData.user_email} onChange={handleChange} />
                {errorMessage.user_email && <div className="error-message" style={{ color: 'red', fontSize: "10px" }}>{errorMessage.user_email}</div>}
                <select id="service_type" onChange={handleChange} style={{ color: "#fff" }}>
                  <option id="service_type" value={formData.service_type} >select</option>
                  <option value="Research Proposal">Research Proposal</option>
                  <option value="Research Paper">Research Paper</option>
                  <option value="Implementation">Implementation</option>
                  <option value="Publication Assistance">Publication Assistance</option>
                  <option value="Polishing">Polishing</option>
                  <option value="Web Hosting">Web Hosting</option>
                  <option value="Email Service">Email Service</option>
                  <option value="SMS Service">SMS Service</option>
                  <option value="Student Management">Student Management</option>
                  <option value="Employee Payroll">Employee Payroll</option>
                  <option value="other">Other</option>
                </select>
                {errorMessage.service_type && <div className="error-message" style={{ color: 'red', fontSize: "10px" }}>{errorMessage.service_type}</div>}
              </div>
              <div className='new_contact_input_message'>
                <textarea type="text" placeholder='Enter your Message' id='user_message' value={formData.user_message} onChange={handleChange}></textarea>
                {errorMessage.user_message && <div className="error-message" style={{ color: 'red', fontSize: "10px" }}>{errorMessage.user_message}</div>}
              </div>

              <div className='seasense_web_form_smt_bts'>
                <button onClick={handleSubmit}>Submit</button>
                {successMessage && <div className="success-message" style={{ color: 'green' }}>{successMessage}</div>}
              </div>
            </div>
          </div>
        </div>

      </div>
      <Whatsapp />
      <Scrolltop />

      <Footer />

    </>
  )
}

export default Home